module.exports = __webpack_public_path__ + "img/62.4386a51d.jpg";